import BaseModel from './base/BaseModel.model';

export default class UrlForm extends BaseModel {

    public url: string | null;
    public label: string | null;
    public isActive: boolean;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.url = null;
        this.label = null;
        this.isActive = true;
    }
}